import { Modal } from 'antd';
import Button from '../Button/Button';
import Delete from '../../assets/icons/Delete';

const EditContentModal = ({
  visible,
  handleCancel,
  saveContent,
  children,
  title,
  callback,
  footer = true,
}) => {
  const close = () => {
    handleCancel();
    callback();
  };
  return (
    <Modal
      width={606}
      visible={visible}
      onOk={handleCancel}
      onCancel={handleCancel}
      footer={null}
    >
      <div className='edit-modal'>
        <div className='edit-modal__heading' style={{ marginBottom: '32px' }}>
          <p>{title}</p>
        </div>
        <div className='edit-modal__body'>{children}</div>
      </div>
      {footer && (
        <div className='edit-modal__bottom'>
          <p onClick={() => handleCancel()}>Cancel</p>
          <Button text='Save' className='primary-btn' onClick={close} />
        </div>
      )}
    </Modal>
  );
};

export default EditContentModal;
